/**
 * Frame element to set same styling for contained content.
 *  
 * @param textBody must be single element. 
 * @returns textBody wrapped inside blogframe.
 */
export default function BlogFrame({ text }) {
  return (
    <div className="blogframe text-justify flex justify-center">
      {text}
    </div>
  );
}